import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleAlert: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-alert, comment, feedback"} maskId="square-filled-radius-0-stroke-1-IconBubbleAlert"><path fillRule="evenodd" clipRule="evenodd" d="M21 3.00002L3 3V19L8.83366 19L11.996 21.6509L15.1957 19H21V3.00002ZM12.5 7V12.5H11.5V7H12.5ZM12.5 14H11.5V15H12.5V14Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubbleAlert;
